/**
 * Theme FAQ accordions (.faqs--wrapper .accordion).
 * Loads with defer (not lazyload2) so taps work on mobile without waiting for scroll.
 */
(function () {
  function initFaqs($) {
    if (!$ || !$.fn) return;

    $('.faqs--wrapper .accordion').each(function () {
      var $btn = $(this);
      if ($btn.data('rg-faq-bound')) return;
      $btn.data('rg-faq-bound', true);
      $btn.on('click', function () {
        $(this).toggleClass('activvve');
        $(this).parent().toggleClass('brighter');
        $(this).siblings('.panel').slideToggle(200);
      });
    });

    function syncAccordionHeights() {
      var $acc = $('.accordion:not(.excludeee)');
      if (!$acc.length) return;
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        $acc.css({ height: '', minHeight: '' });
        return;
      }
      var maxHeight = 0;
      $acc.each(function () {
        var h = $(this).outerHeight();
        if (h > maxHeight) maxHeight = h;
      });
      if (maxHeight > 0) {
        $acc.height(maxHeight);
      }
    }

    $(window).on('load resize', syncAccordionHeights);
    syncAccordionHeights();
  }

  function waitJq() {
    if (window.jQuery) {
      window.jQuery(initFaqs);
    } else {
      setTimeout(waitJq, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitJq);
  } else {
    waitJq();
  }
})();
